const defaultPaginationDetails = {
  currentPage: 0,
  totalPages: 0,
  pageSize: 0,
  totalData: 0,
};

const updatedDefaultPaginationDetails = {
  currentPage: 1,
  totalPages: 0,
  pageSize: 10,
  totalData: 0,
};

const createObject = () => ({
  data: [],
  paginationDetails: updatedDefaultPaginationDetails,
});

export default {
  orgDetails: null,
  orgDosingDetails: null,
  orgLocations: [],
  orgDosingUsers: [],
  orgUserLookup: [],
  orgList: {
    data: [],
    paginationDetails: defaultPaginationDetails,
  },
  orgUsers: {
    data: [],
    paginationDetails: defaultPaginationDetails,
  },
  deaLicenses: [],
  medicalLicenses: [],
  npi: [],
  orgManagementList: createObject(),
};
